import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

type CreateUser = {
    user: UserWrite;
};
export const useCreateUser = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: CreateUser) => {
            const { user } = options;

            if (user.id !== undefined) {
                return await loggedInApiCall.patch(
                    "/api/users/" + user.id,
                    Object.fromEntries(Object.entries(user).filter(([key]) => key !== "id")),
                    {
                        headers: {
                            "Content-Type": "application/merge-patch+json",
                        },
                    },
                );
            }

            return await loggedInApiCall.post("/api/users", user);
        },
        onSuccess: () => queryClient.invalidateQueries(["allUsers"]),
    });

    return query;
};

export type UserWrite = {
    id?: number;
    firstname: string;
    lastname: string;
    email: string;
    password?: string;
    plainPassword?: string;
    phone?: string;
    companies?: Array<IRI>;
    roles?: Array<string>;
    jsonAttributes?: Record<string, any>;
};
